import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-293">
      <div className="max-w-3xl mx-auto text-center" data-id="element-294">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-295">
          Si sos docente de Francés en Argentina,
          <br data-id="element-296" />
          <span className="text-[#00B4D8]" data-id="element-297">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-298">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-299">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-300">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-301">
              Domingo a la noche buscando actividades en internet que nunca
              quedan bien, están en francés demasiado avanzado o no se adaptan
              al alumno argentino que recién empieza
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-302">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-303">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-304">
              Llegás al lunes con algo que "más o menos sirve" y durante la
              clase te das cuenta que le falta estructura, cierre, solucionario
              y evaluación
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-305">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-306">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-307">
              Tenés que armar planificaciones para jefatura o dirección del
              instituto a las corridas, la noche anterior, sin saber si están
              bien formuladas para el nivel MCER
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-308">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-309">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-310">
              Tus evaluaciones son siempre las mismas o siempre inventadas
              porque no tenés un banco de instrumentos serios con solucionario
              incluido
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-311">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-312">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-313">
              Cuando el tema es difícil —el subjonctif, el conditionnel, los
              pronombres relativos— no sabés cómo explicarlo sin perder al grupo
              en el camino
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-314">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-315">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-316">
              Tenés alumnos con niveles muy distintos en el mismo grupo (A1 con
              A2 o A2 con B1) y no tenés material diferenciado — así que das
              para el promedio y perdés a todos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-317">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-318">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-319">
              El material que encontrás online está en francés demasiado formal,
              no conecta con la cultura francesa real y encima está incompleto
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-320">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-321">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-322">
              Trabajás de lunes a viernes, llegás al fin de semana agotado/a y
              el domingo volvés a empezar el ciclo de buscar, armar e improvisar
            </p>
          </div>
        </div>

        <p className="text-[#00B4D8] text-2xl sm:text-3xl font-black mb-8" data-id="element-323">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Blue divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#00B4D8] to-transparent w-full" data-id="element-324" />
      </div>
    </section>;
}